import * as React from "react";
import { Loader } from "@grandvisionhq/common";
import { useIntl } from "@grandvisionhq/state";
import { useRemoveFromCart } from "../../../../../../hooks/hooks/use-remove-from-cart.js";
import { RemoveButton } from "../../../../components/modules/Upsell/components/RemoveButton.js";
/* empty css                                                               */
const RemoveButtonContainer = ({ lineItem, onSuccess }) => {
  const [removeFromCart, { loading }] = useRemoveFromCart(lineItem, onSuccess);
  const { getLabel } = useIntl();
  const labels = React.useMemo(
    () => ({
      removeFromCart: getLabel("cart.actions.removeFromCart")
    }),
    [getLabel]
  );
  return loading ? /* @__PURE__ */ React.createElement(Loader, { className: "remove-button__loader" }) : /* @__PURE__ */ React.createElement(RemoveButton, { caption: labels.removeFromCart, onClick: removeFromCart });
};
export {
  RemoveButtonContainer
};
//# sourceMappingURL=RemoveButtonContainer.js.map
